import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const EventConfiguration = {
	name: NAME,
	apiProvider,
	router,
};
